import LoadingSquare from "shared/components/loading/LoadingSquare.js";
import MiscCompetitionRanking from "shared/components/misc/MiscCompetitionRanking";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";
import ControllerSeasons from "shared/components/controllers/ControllerSeasons.js";

interface PopupCompetitionProps {
  className?: string;
  competition: any;
  trigger?: React.ReactNode;
  open?: boolean;
  onClose?: () => void;
}

const PopupCompetition: React.FC<PopupCompetitionProps> = ({ className = "", competition, trigger, open, onClose }) => {
  const navigate = useNavigate();
  const [selectedCompetition, setSelectedCompetition] = useState(null);

  return (
    <div className="PopupCompetition d-flex flex-fill">
      <Popup
        trigger={trigger}
        modal
        closeOnDocumentClick={false}
        className={`fade-in popup-xl ${className}`}
        {...(open !== undefined ? { open, onClose } : {})}
      >
        {(close) => (
          <div>
            <div className="d-flex flex-row mb-3">
              <div className="flex-grow-1">
                <h2 className="text-white">
                  <i className="bi bi-trophy-fill me-1" />
                  {competition.name}
                </h2>
              </div>
              <div className="flex-grow-0">
                <button className="btn" onClick={close}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <div className="d-flex flex-column flex-md-row m-1 mb-2">
              <div className="d-flex flex-column flex-fill">
                <ControllerSeasons competitionName={competition.name} onChange={(c) => setSelectedCompetition(c)} />

                {selectedCompetition ? (
                  <MiscCompetitionRanking
                    key={selectedCompetition?.id}
                    competition={selectedCompetition}
                    clubToHighlight={[]}
                  />
                ) : (
                  <LoadingSquare />
                )}
              </div>
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default PopupCompetition;
